import type { TrafficResult } from '@apm/contracts';
import { alignToBuckets, bucketStarts, type TrendSeries } from '../charts/trend';
import { STATUS, TX_COLOR } from '../theme';

/**
 * 트레이스만 서비스의 초당 요청·오류·응답시간 계열 (34회차).
 *
 * 스냅샷이 오는 서비스는 `live/trend.ts`가 1초 값을 화면에서 모아 같은 그림을 그린다.
 * 스냅샷이 없는 서비스는 모을 1초 값 자체가 없어 **서버가 끝난 요청을 1분으로 접은 것**
 * (`GET /api/rt/traffic`)을 그대로 받는다. 여기서는 그것을 계열로 옮기기만 한다.
 *
 * 두 화면이 계산을 나눠 갖는 이유는 소스가 하나여야 하기 때문이다 — 스냅샷이 오는 서비스에
 * 서버 집계까지 쓰면 같은 그림에 값이 둘 생기고, 어긋났을 때 어느 쪽이 맞는지 말할 수 없다.
 */

/** 계열 순서. 초당 오류 선을 누르면 부르는 쪽이 상태=오류까지 건다 */
export const TRAFFIC_ERROR_SERIES = 1;

/** 서버가 준 구간을 그래프 계열로. 요청이 없던 구간은 빈 자리로 남는다 */
export function trafficSeries(result: TrafficResult): {
  buckets: number[];
  series: TrendSeries[];
} {
  const from = result.at - result.minutes * 60_000;
  const buckets = bucketStarts(from, result.at, result.bucketMs);
  return {
    buckets,
    series: [
      {
        label: '초당 요청',
        color: TX_COLOR.http,
        unit: 'rate',
        shape: 'bar',
        values: alignToBuckets(result.rows, buckets, (row) => row.requestsPerSec),
      },
      {
        label: '초당 오류',
        color: STATUS.error,
        unit: 'rate',
        shape: 'line',
        values: alignToBuckets(result.rows, buckets, (row) => row.errorsPerSec),
      },
      {
        label: '응답시간(느린 5%)',
        color: TX_COLOR.slow,
        unit: 'ms',
        shape: 'line',
        values: alignToBuckets(result.rows, buckets, (row) => row.p95Ms),
      },
    ],
  };
}
